
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 1.5A28.54 28.54 0 001.5 30.08C3 68 57 68 58.5 30.08A28.54 28.54 0 0030 1.5z","fill":"#2d8cff"}}),_c('path',{attrs:{"d":"M47 38.13c0 1.51-1.23 2-2.4 1.18-2.18-1.52-4.34-3.07-6.51-4.6v3.11c0 1.35-.67 2-2.05 2H18.33c-3.75 0-6.28-2.46-6.28-6.12V22.18c0-1.37.65-2 2-2 4.77.09 13.11 0 17.79 0A5.81 5.81 0 0138 25.29c2.19-1.55 4.38-3.11 6.58-4.65 1-.74 2.35-.5 2.4 1.18.02 5.27.02 11.03.02 16.31z","fill":"#fff"}})])
          )
        }
      }
    